module.exports = __webpack_public_path__ + "static/media/Sala.1ecf8f43.jpg";